import { flowWithSafeComponent } from '@atlassian/jira-issue-view-common-utils/src/flow-with-safe-component/index.tsx';
import { connect } from '@atlassian/jira-issue-view-react-redux/src/index.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import { getChildIssuesPanelType, getParentKey } from '../../state/context/selectors.tsx';
import type { State } from '../../state/types.tsx';
import { ChildIssuesLimitPanel as View } from './main.tsx';

export const ChildIssuesLimitPanel = flowWithSafeComponent(
	ComponentWithAnalytics('item', {
		onBulkEditClicked: 'clicked',
	}),
	withFireUiAnalytics({
		// @ts-expect-error - TS7006 - Parameter 'issueCount' implicitly has an 'any' type.
		onBulkEditClicked: (issueCount) => ({
			name: 'bulkEdit',
			issueCount,
		}),
	}),
	// @ts-expect-error - Argument of type 'InferableComponentEnhancerWithProps<{ baseUrl: string; childIssuesPanelType: ChildIssuesPanelType | null; parentKey: string | null; hideDone: boolean; allIssues: ChildIssue[]; incompleteIssues: ChildIssue[]; } & { ...; }, {}>' is not assignable to parameter of type 'FlowStep<WithUIAnalyticsEvent<PropsWithoutRef<Omit<{ [K in keyof Props]: K extends "onBulkEditClicked" | "onViewInSearchClicked" | "onHideDoneClicked" ? (...args: [...Parameters<Props[K]>, UIAnalyticsEvent]) => ReturnType<...> : Props[K]; }, keyof WithAnalyticsEventsProps>>, { ...; }>, ConnectedComponent<...>>'.
	connect((state: State, props: { hasExceededIssuesLimitInitialLoad: boolean }) => {
		// FIXME: JIV-17455 can be null
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		const childIssuesPanelType = getChildIssuesPanelType(state)!;

		return {
			childIssuesPanelType,
			hasExceededIssuesLimitInitialLoad: props.hasExceededIssuesLimitInitialLoad,
			parentKey: getParentKey(state),
		};
	}, {}),
)(View);
